import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import Propinsi from "../../../../utilities/Propinsi";
import KotaKab from "../../../../utilities/KotaKab";
import StatusChecklist from "../../../../utilities/StatusChecklist";
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import Card from "../../../../components/Card";
import { AsyncPaginate } from "react-select-async-paginate";
import DataTable from "react-data-table-component";
import { FaPaperPlane } from "react-icons/fa";
import SweetAlert from "react-bootstrap-sweetalert";
import MasterService from "../../../../services/master/MasterService";
import { romanNum } from "../../../../utilities/Utils";
import { FaGear } from "react-icons/fa6";
import ModalSyncNIB from "../../base/modal/ModalSyncNIB";

const DaftarCpib = () => {
    const columns = [
        {
            name: 'Permohonan',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12">
                            <b>Nomor Permohonan :</b>
                        </div>
                        <div className="col-12">
                            {row['idIzin']}
                        </div>
                        <div className="col-12">
                            <b>Tanggal Permohonan :</b>
                        </div>
                        <div className="col-12">
                            {row['tglPermohonan']}
                        </div>
                    </div>
                </>
            )
        },
        {
            name: 'Perusahaan',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12">
                            <b>NIB :</b>
                        </div>
                        <div className="col-12">
                            {row['nib']}
                        </div>
                        <div className="col-12">
                            <b>Nama Perusahaan :</b>
                        </div>
                        <div className="col-12">
                            {row['namaPerseroan']}
                        </div>
                    </div>
                </>
            ),
            grow: 0.75
        },
        {
            name: 'No Kegiatan Usaha',
            cell: row => row['nomorProyek'],
        },
        {
            name: 'Usaha',
            cell: row => row['uraianUsaha'],
            grow: 0.75
        },
        {
            name: 'Propinsi',
            cell: row => <Propinsi id={row['kdProp']} />,
            grow: 0.5
        },
        {
            name: 'Kota/Kab',
            cell: row => <KotaKab id={row['kdKota']} />,
            grow: 0.5
        },
        {
            name: 'Status Izin',
            cell: row => <StatusChecklist kode={row['statusChecklist']} />,
            grow: 0.75
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    {
                        row['statusChecklist'] === '45' &&
                        <>
                            <div className="col-md-12 mb-3 mt-2">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Proses Permohonan</Tooltip>
                                }>
                                    <Button size="sm" variant="primary" onClick={() => handleClickConfirmProses(row)}>
                                        <FaPaperPlane />{' '} Proses
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </>
                    }
                </div>
            ),
            grow: 0.5
        }
    ]

    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSearchNib, setValueSearchNib] = useState(null)
    const onChangeSearchNib = e => {
        setValueSearchNib(e.target.value)
    }

    const getDataOss = useCallback(async (page, size) => {
        setLoading(true)
        try {
            let resList
            if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
                resList = await pbumkuService.listDataOss('032000000034', null, localStorage.getItem("kdUnit"), null, page, size)
            } else {
                resList = await pbumkuService.listDataOss('032000000034', null, null, null, page, size)
            }
            setListData(resList.data.data)
            setTotalData(resList.data.totalData)
        } catch (error) {
            setListData(null)
        }
        setLoading(false)
    }, [pbumkuService])

    useEffect(() => {
        getDataOss(0, 10)
    }, [getDataOss])

    const handleChangePage = (page) => {
        getDataOss(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        let resList
        if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
            resList = await pbumkuService.listDataOss('032000000034', valueSearchNib, localStorage.getItem("kdUnit"), valueSearchStatusOpt?.stsChecklist, page - 1, size)
        } else {
            resList = await pbumkuService.listDataOss('032000000034', valueSearchNib, null, valueSearchStatusOpt?.stsChecklist, page - 1, size)
        }
        setListData(resList.data.data)
        setSize(size)
    }

    const [valueSearchStatusOpt, setValueSearchStatusOpt] = useState(null)
    async function loadOptionStatusChecklist(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listStatusChecklist(search, page - 1, size)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeStatus = e => {
        setValueSearchStatusOpt(e)
    }

    const onClickCari = async () => {
        let resList
        if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
            resList = await pbumkuService.listDataOss('032000000034', valueSearchNib, localStorage.getItem("kdUnit"), valueSearchStatusOpt?.stsChecklist, 0, 10)
        } else {
            resList = await pbumkuService.listDataOss('032000000034', valueSearchNib, null, valueSearchStatusOpt?.stsChecklist, 0, 10)
        }
        setListData(resList.data.data)
        setTotalData(resList.data.totalData)
    }

    const onClickReset = () => {
        setValueSearchNib(null)
        setValueSearchStatusOpt(null)
        getDataOss(0, 10)
    }

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [dataPrimer, setDataPrimer] = useState(null)
    const [loadingProses, setLoadingProses] = useState(false)

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => {
        setShowConfirmProses(false)
    }
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)
    const handleClickConfirmProses = (row) => {
        setDataPrimer(row)
        setShowConfirmProses(true)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let nomorAju
            let kdUnit
            const uptByKota = await masterService.getKotaById(dataPrimer.kdKota)
            if (uptByKota === undefined && uptByKota.data === null && uptByKota.data.kodeUpt === undefined) {
                kdUnit = localStorage.getItem('kdUnit')
            } else {
                kdUnit = uptByKota?.data?.kodeUpt
            }
            const respNomor = await pbumkuService.ambilNomorService('PPM_CPIB', kdUnit, currentYear, localStorage.getItem('username'))
            //O-CPPIB-040-VIII-2026-00001
            nomorAju = 'O-' + respNomor.data.uraianPusat + '-' + respNomor.data.kodePusat + '-' + romanNum(currentMonth) + '-' + currentYear + '-' + respNomor.data.nomorUrut

            let jsonUmkuHeader = {
                nomorAju: nomorAju,
                asalData: 'O',
                idoss: dataPrimer.idOss,
                idpryk: dataPrimer.idPryk,
                idchecklist: dataPrimer.idChecklist,
                kdUnit: kdUnit,
                kdIzin: '032000000034',
                kodeStatus: '023',
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            const resUmkuHeader = await pbumkuService.saveUmkuHeader(jsonUmkuHeader)
            if (resUmkuHeader.data.kode === '200') {
                let jsonUmkuDisposisi = {
                    nomorAju: nomorAju,
                    idDisposisi: 4,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuPenugasan(jsonUmkuDisposisi)

                let jsonUmkuStatus = {
                    nomorAju: nomorAju,
                    kodeStatus: '010',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonUmkuStatus)

                jsonUmkuStatus = {
                    nomorAju: nomorAju,
                    kodeStatus: '023',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonUmkuStatus)

                setShowConfirmProses(false)
                setShowProsesSuccess(true)
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickProsesSuccess = () => {
        setShowProsesSuccess(false)
        getDataOss(0, 10)
    }

    const handleClickProsesFailed = () => {
        setShowProsesFailed(false)
    }

    const [showSync, setShowSync] = useState(false)
    const handleCloseSync = () => setShowSync(false)
    const handleClickSync = () => {
        setShowSync(true)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">NIB</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="NIB" className="form-control-sm" value={valueSearchNib} onChange={onChangeSearchNib} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Status Permohonan</Form.Label>
                                            <Col sm="9">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionStatusChecklist}
                                                    value={valueSearchStatusOpt}
                                                    getOptionLabel={(option) => option.keterangan}
                                                    getOptionValue={(option) => option.stsChecklist}
                                                    additional={{
                                                        page: 1
                                                    }}
                                                    onChange={onChangeStatus}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => onClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => onClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Permohonan Cara Pembenihan Ikan yang Baik (CPIB) Melalui OSS</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Button type="button" variant="secondary" size="sm" onClick={() => handleClickSync()}><FaGear /> Tarik NIB dari OSS</Button>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalSyncNIB showSync={showSync} handleCloseSync={handleCloseSync}/>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Permohonan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingProses}
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Proses Data Berhasil"
                    onConfirm={handleClickProsesSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Proses Data Gagal"
                    onConfirm={handleClickProsesFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default DaftarCpib